module.exports = __webpack_public_path__ + "assets/img/bg-m@2x.3f435206.png";